import { Button, Modal, Form, Select, Row } from "antd";
import { userGenerateJwtTokenUrl } from "./endpoints";
import { getApis } from "./apis";
import { useState } from "react";
import { setOrgDetails } from "./Utils";
import { DEMO_EMAIL } from "./Constants";

const ChangeOrganisation = ({ isModalOpen, handleCloseModal }) => {
  const [finishBtnLoader, setFinishBtnLoader] = useState(false);
  const userToken = localStorage.getItem("userToken");
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const onFinish = async (values) => {
    setFinishBtnLoader(true);
    await getApis(userGenerateJwtTokenUrl, { orgId: values?.org }, userToken)
      .then((response) => {
        setOrgDetails(response?.data, values?.org);
        window.location.reload();
        setFinishBtnLoader(false);
      })
      .catch((e) => {
        console.log(e.response?.data?.message);
        setFinishBtnLoader(false);
      });
  };

  return (
    <Modal
      title="Change Organisation"
      open={isModalOpen}
      onCancel={handleCloseModal}
      footer={[]}
    >
      <Form
        layout="vertical"
        initialValues={{ org: userDetails?.currentOrganisation?.id }}
        onFinish={onFinish}
        name="orgSwitchForm"
        className="mt105 org-change-form"
      >
        Select Organisation
        <Form.Item name="org" className="mt1">
          <Select
            showSearch
            size="large"
            disabled={finishBtnLoader}
            style={{ width: "100%" }}
            options={userDetails?.otherOrganisations?.map((i, index) => ({
              label:
                userDetails?.email === DEMO_EMAIL
                  ? "Organisation " + (index + 1)
                  : i.name,
              value: i.id,
            }))}
          />
        </Form.Item>
        <Form.Item className="mb0">
          <Row justify={"end"}>
            <Button
              role="BackBtn"
              className="cancel-btn"
              htmlType="button"
              disabled={finishBtnLoader}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              data-testid="submitBtn"
              type="primary"
              className="submit-btn"
              htmlType="submit"
              loading={finishBtnLoader}
            >
              Submit
            </Button>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangeOrganisation;
